import { render } from "./FolderBtn.vue?vue&type=template&id=77500544&scoped=true"
import script from "./FolderBtn.vue?vue&type=script&lang=js"
export * from "./FolderBtn.vue?vue&type=script&lang=js"

import "./FolderBtn.vue?vue&type=style&index=0&id=77500544&lang=sass&scoped=true"

import exportComponent from "C:\\Riman\\Web\\Alex\\newmapper\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77500544"]])

export default __exports__